<p-dialog
  [(visible)]="internalShowDialog"
  (onHide)="onClose()"
  (onShow)="onDialogShow()"
  [modal]="true"
  [style]="{ width: '950px', maxWidth: '98vw', maxHeight: '98vh' }"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  styleClass="front-panel"
  [closable]="false"
>
  <ng-template #header>
    <div class="release-news-header" data-cy="release-news_header">
      <h1 class="release-news-title">{{ 'news.whats-new' | translate }}</h1>
      @if ((whatsNewFeatureFlag$ | async)?.canManipulate && !editNewsMode) {
      <div class="release-news-action">
        @if ((news$ | async).id !== 0) {
        <button
          mat-icon-button
          data-cy="edit-whats-new"
          type="button"
          class="release-news-action"
          (click)="onEdit(false)"
          [matTooltip]="'news.editTip' | translate"
        >
          <mat-icon color="accent" [svgIcon]="'pencil'"></mat-icon>
        </button>
        }
        <button
          mat-icon-button
          data-cy="add-whats-new"
          type="button"
          class="release-news-action"
          (click)="onEdit(true)"
          [matTooltip]="'news.addTip' | translate"
        >
          <mat-icon color="accent" [svgIcon]="'plus-circle'"></mat-icon>
        </button>
      </div>
      }
    </div>
    <div class="close-button">
      <p-button
        styleClass="p-button-icon-only"
        [text]="true"
        [rounded]="true"
        (click)="closeDialog()"
        data-cy="close-what-new"
        icon="pi pi-times"
      ></p-button>
    </div>
  </ng-template>
  <section class="dialog-container" #dialogContainer>
    <div>
      @if (!editNewsMode) {
      <div class="release-news-content" data-cy="release-news_container" [innerHTML]="(news$ | async)?.content"></div>
      } @if ((whatsNewFeatureFlag$ | async)?.canManipulate && editNewsMode) {
      <form (submit)="onSubmit()" [formGroup]="newsForm">
        <div>
          <p-editor
            [modules]="editorModules"
            [style]="{ height: '320px' }"
            formControlName="newsInformation"
          ></p-editor>
        </div>
        @if (editNewsMode) {
        <div class="release-news-button">
          <button
            mat-flat-button
            type="button"
            color="accent"
            (click)="onSubmit()"
            [disabled]="newsForm.invalid || !newsForm.dirty"
            data-cy="add-button"
          >
            @if (!addNewsMode) {
            <span>{{ 'global.save' | translate }}</span>
            } @if (addNewsMode) {
            <span>{{ 'news.add' | translate }}</span>
            }
          </button>
          <button mat-flat-button type="button" (click)="onCancel()">
            {{ 'global.cancel' | translate }}
          </button>
        </div>
        }
      </form>
      } @if (!editNewsMode) {
      <div class="release-news-button">
        <button mat-flat-button type="button" (click)="closeDialog()">
          {{ 'global.close' | translate }}
        </button>
      </div>
      }
    </div>
  </section>
</p-dialog>
